import React from 'react';
import { formatEventDate } from '../../lib/recurrence';

// Horizontal chip picker for choosing one occurrence date of a recurring event.
// `dates` is either an array of ISO strings or objects { date, registration_count, is_past }.
export const OccurrencePicker = ({ dates, value, onChange, testIdPrefix = 'occurrence' }) => {
  const items = (dates || []).map((d) => (typeof d === 'string' ? { date: d } : d));
  if (items.length === 0) return null;
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1" data-testid={`${testIdPrefix}-picker`}>
      {items.map((o) => {
        const on = o.date === value;
        return (
          <button
            key={o.date}
            type="button"
            onClick={() => onChange(o.date)}
            className={`flex-shrink-0 rounded-xl px-3 py-2 text-left border transition-colors ${
              on
                ? 'bg-[#00FFFF]/15 border-[#00FFFF] text-white'
                : 'bg-white/5 border-white/10 text-gray-300 hover:border-white/30'
            } ${o.is_past ? 'opacity-60' : ''}`}
            aria-pressed={on}
            data-testid={`${testIdPrefix}-${o.date}`}
          >
            <span className="block text-xs font-bold whitespace-nowrap">{formatEventDate(o.date)}</span>
            {typeof o.registration_count === 'number' && (
              <span className={`block text-[10px] mt-0.5 ${on ? 'text-[#00FFFF]' : 'text-gray-500'}`}>
                {o.registration_count} RSVP{o.registration_count === 1 ? '' : 's'}
                {o.checked_in_count > 0 ? ` · ${o.checked_in_count} in` : ''}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
